/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ([
/* 0 */,
/* 1 */
/***/ ((module) => {



    var stylesInDOM = [];
    function getIndexByIdentifier(identifier) {
      var result = -1;
      for (var i = 0; i < stylesInDOM.length; i++) {
        if (stylesInDOM[i].identifier === identifier) {
          result = i;
          break;
        }
      }
      return result;
    }
    function modulesToDom(list, options) {
      var idCountMap = {};
      var identifiers = [];
      for (var i = 0; i < list.length; i++) {
        var item = list[i];
        var id = options.base ? item[0] + options.base : item[0];
        var count = idCountMap[id] || 0;
        var identifier = "".concat(id, " ").concat(count);
        idCountMap[id] = count + 1;
        var indexByIdentifier = getIndexByIdentifier(identifier);
        var obj = {
          css: item[1],
          media: item[2],
          sourceMap: item[3],
          supports: item[4],
          layer: item[5]
        };
        if (indexByIdentifier !== -1) {
          stylesInDOM[indexByIdentifier].references++;
          stylesInDOM[indexByIdentifier].updater(obj);
        } else {
          var updater = addElementStyle(obj, options);
          options.byIndex = i;
          stylesInDOM.splice(i, 0, {
            identifier: identifier,
            updater: updater,
            references: 1
          });
        }
        identifiers.push(identifier);
      }
      return identifiers;
    }
    function addElementStyle(obj, options) {
      var api = options.domAPI(options);
      api.update(obj);
      var updater = function updater(newObj) {
        if (newObj) {
          if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
            return;
          }
          api.update(obj = newObj);
        } else {
          api.remove();
        }
      };
      return updater;
    }
    module.exports = function (list, options) {
      options = options || {};
      list = list || [];
      var lastIdentifiers = modulesToDom(list, options);
      return function update(newList) {
        newList = newList || [];
        for (var i = 0; i < lastIdentifiers.length; i++) {
          var identifier = lastIdentifiers[i];
          var index = getIndexByIdentifier(identifier);
          stylesInDOM[index].references--;
        }
        var newLastIdentifiers = modulesToDom(newList, options);
        for (var _i = 0; _i < lastIdentifiers.length; _i++) {
          var _identifier = lastIdentifiers[_i];
          var _index = getIndexByIdentifier(_identifier);
          if (stylesInDOM[_index].references === 0) {
            stylesInDOM[_index].updater();
            stylesInDOM.splice(_index, 1);
          }
        }
        lastIdentifiers = newLastIdentifiers;
      };
    };
    
    /***/ }),
    /* 2 */
    /***/ ((module) => {
    
    
    
    /* istanbul ignore next  */
    function apply(styleElement, options, obj) {
      var css = "";
      if (obj.supports) {
        css += "@supports (".concat(obj.supports, ") {");
      }
      if (obj.media) {
        css += "@media ".concat(obj.media, " {");
      }
      var needLayer = typeof obj.layer !== "undefined";
      if (needLayer) {
        css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
      }
      css += obj.css;
      if (needLayer) {
        css += "}";
      }
      if (obj.media) {
        css += "}";
      }
      if (obj.supports) {
        css += "}";
      }
      var sourceMap = obj.sourceMap;
      if (sourceMap && typeof btoa !== "undefined") {
        css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
      }
    
      // For old IE
      /* istanbul ignore if  */
      options.styleTagTransform(css, styleElement, options.options);
    }
    function removeStyleElement(styleElement) {
      // istanbul ignore if
      if (styleElement.parentNode === null) {
        return false;
      }
      styleElement.parentNode.removeChild(styleElement);
    }
    
    /* istanbul ignore next  */
    function domAPI(options) {
      if (typeof document === "undefined") {
        return {
          update: function update() {},
          remove: function remove() {}
        };
      }
      var styleElement = options.insertStyleElement(options);
      return {
        update: function update(obj) {
          apply(styleElement, options, obj);
        },
        remove: function remove() {
          removeStyleElement(styleElement);
        }
      };
    }
    module.exports = domAPI;
    
    /***/ }),
    /* 3 */
    /***/ ((module) => {
    
    
    
    var memo = {};
    
    /* istanbul ignore next  */
    function getTarget(target) {
      if (typeof memo[target] === "undefined") {
        var styleTarget = document.querySelector(target);
    
        // Special case to return head of iframe instead of iframe itself
        if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
          try {
            // This will throw an exception if access to iframe is blocked
            // due to cross-origin restrictions
            styleTarget = styleTarget.contentDocument.head;
          } catch (e) {
            // istanbul ignore next
            styleTarget = null;
          }
        }
        memo[target] = styleTarget;
      }
      return memo[target];
    }
    
    /* istanbul ignore next  */
    function insertBySelector(insert, style) {
      var target = getTarget(insert);
      if (!target) {
        throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
      }
      target.appendChild(style);
    }
    module.exports = insertBySelector;
    
    /***/ }),
    /* 4 */
    /***/ ((module, __unused_webpack_exports, __webpack_require__) => {
    
    
    
    /* istanbul ignore next  */
    function setAttributesWithoutAttributes(styleElement) {
      var nonce =  true ? __webpack_require__.nc : 0;
      if (nonce) {
        styleElement.setAttribute("nonce", nonce);
      }
    }
    module.exports = setAttributesWithoutAttributes;
    
    /***/ }),
    /* 5 */
    /***/ ((module) => {
    
    
    
    /* istanbul ignore next  */
    function insertStyleElement(options) {
      var element = document.createElement("style");
      options.setAttributes(element, options.attributes);
      options.insert(element, options.options);
      return element;
    }
    module.exports = insertStyleElement;
    
    /***/ }),
    /* 6 */
    /***/ ((module) => {
    
    
    
    /* istanbul ignore next  */
    function styleTagTransform(css, styleElement) {
      if (styleElement.styleSheet) {
        styleElement.styleSheet.cssText = css;
      } else {
        while (styleElement.firstChild) {
          styleElement.removeChild(styleElement.firstChild);
        }
        styleElement.appendChild(document.createTextNode(css));
      }
    }
    module.exports = styleTagTransform;
    
    /***/ }),
    /* 7 */
    /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
    
    __webpack_require__.r(__webpack_exports__);
    /* harmony export */ __webpack_require__.d(__webpack_exports__, {
    /* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
    /* harmony export */ });
    /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (__webpack_require__.p + "css/readmore.min.css");
    
    /***/ }),
    /* 8 */,
    /* 9 */
    /***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {
    
    __webpack_require__.r(__webpack_exports__);
    /* harmony export */ __webpack_require__.d(__webpack_exports__, {
    /* harmony export */   "default": () => (/* binding */ Readmore)
    /* harmony export */ });
    function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
    function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
    function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
    function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
    function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
    function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
    var Readmore = /*#__PURE__*/function () {
      function Readmore(defaultOptions) {
        _classCallCheck(this, Readmore);
        this.selectors = document.querySelectorAll('[data-readmore]');
        this.options = {
          buttonClasses: '',
          maxcChar: 200,
          moreLink: "Read more",
          lessLink: "Read less",
          disabledLessLink: false
        };
        if (_typeof(defaultOptions) == 'object') {
          this["default"] = _objectSpread(_objectSpread({}, this.options), defaultOptions);
        } else {
          this["default"] = this.options;
        }
      }
      _createClass(Readmore, [{
        key: "render",
        value: function render() {
          var _this = this;
          this.selectors.forEach(function (element, index) {
            var txtElement = element.querySelector('span:first-child');
            var settings = element.dataset.readmore !== '' ? JSON.parse(element.dataset.readmore) : '';
            if (_typeof(settings) == 'object' && Object.keys(settings).length) {
              _this["default"] = _objectSpread(_objectSpread({}, _this["default"]), settings);
            }
            if (_this.isEllipsisActive(txtElement)) {
              _this.createButtons(element, index);
              _this.createInput(element, index);
              _this.createShortDesc(element, txtElement, index);
            }
          });
        }
      }, {
        key: "createShortDesc",
        value: function createShortDesc(parentElement, textElement, index) {
          var span = document.createElement("span");
          var shortTxt = this.shortDescTxt(textElement.textContent, this["default"].maxcChar);
          span.classList.add('short-' + index);
          span.textContent = shortTxt + '';
          parentElement.insertBefore(span, textElement);
        }
      }, {
        key: "shortDescTxt",
        value: function shortDescTxt(str, maxChar) {
          var content = str.replace(/\n/g, " ").substring(0, parseInt(maxChar));
          return content;
        }
      }, {
        key: "isEllipsisActive",
        value: function isEllipsisActive(el) {
          return el.offsetWidth < el.scrollWidth;
        }
      }, {
        key: "createButtons",
        value: function createButtons(parentElement, index) {
          var label = document.createElement("label");
          var span = document.createElement('span');
          label.setAttribute('for', 'readmore-' + index);
          label.setAttribute('class', this["default"].buttonClasses);
          span.textContent = this["default"].moreLink;
          if (!this["default"].disabledLessLink) {
            var _span = document.createElement('span');
            _span.textContent = this["default"].lessLink;
    
            // Add read less button
            label.appendChild(_span);
          }
    
          // Add Read more Button 
          label.appendChild(span);
    
          // Add label
          parentElement.appendChild(label);
        }
      }, {
        key: "createInput",
        value: function createInput(parentElement, index) {
          var input = document.createElement("input");
          input.style.display = 'none';
          input.setAttribute('id', 'readmore-' + index);
          input.classList.add('readmore-' + index);
          input.type = 'checkbox';
          parentElement.insertAdjacentElement('beforebegin', input);
        }
      }]);
      return Readmore;
    }();
    
    
    /***/ })
    /******/ 	]);
    /************************************************************************/
    /******/ 	// The module cache
    /******/ 	var __webpack_module_cache__ = {};
    /******/ 	
    /******/ 	// The require function
    /******/ 	function __webpack_require__(moduleId) {
    /******/ 		// Check if module is in cache
    /******/ 		var cachedModule = __webpack_module_cache__[moduleId];
    /******/ 		if (cachedModule !== undefined) {
    /******/ 			return cachedModule.exports;
    /******/ 		}
    /******/ 		// Create a new module (and put it into the cache)
    /******/ 		var module = __webpack_module_cache__[moduleId] = {
    /******/ 			// no module.id needed
    /******/ 			// no module.loaded needed
    /******/ 			exports: {}
    /******/ 		};
    /******/ 	
    /******/ 		// Execute the module function
    /******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
    /******/ 	
    /******/ 		// Return the exports of the module
    /******/ 		return module.exports;
    /******/ 	}
    /******/ 	
    /************************************************************************/
    /******/ 	/* webpack/runtime/compat get default export */
    /******/ 	(() => {
    /******/ 		// getDefaultExport function for compatibility with non-harmony modules
    /******/ 		__webpack_require__.n = (module) => {
    /******/ 			var getter = module && module.__esModule ?
    /******/ 				() => (module['default']) :
    /******/ 				() => (module);
    /******/ 			__webpack_require__.d(getter, { a: getter });
    /******/ 			return getter;
    /******/ 		};
    /******/ 	})();
    /******/ 	
    /******/ 	/* webpack/runtime/define property getters */
    /******/ 	(() => {
    /******/ 		// define getter functions for harmony exports
    /******/ 		__webpack_require__.d = (exports, definition) => {
    /******/ 			for(var key in definition) {
    /******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
    /******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
    /******/ 				}
    /******/ 			}
    /******/ 		};
    /******/ 	})();
    /******/ 	
    /******/ 	/* webpack/runtime/global */
    /******/ 	(() => {
    /******/ 		__webpack_require__.g = (function() {
    /******/ 			if (typeof globalThis === 'object') return globalThis;
    /******/ 			try {
    /******/ 				return this || new Function('return this')();
    /******/ 			} catch (e) {
    /******/ 				if (typeof window === 'object') return window;
    /******/ 			}
    /******/ 		})();
    /******/ 	})();
    /******/ 	
    /******/ 	/* webpack/runtime/hasOwnProperty shorthand */
    /******/ 	(() => {
    /******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
    /******/ 	})();
    /******/ 	
    /******/ 	/* webpack/runtime/make namespace object */
    /******/ 	(() => {
    /******/ 		// define __esModule on exports
    /******/ 		__webpack_require__.r = (exports) => {
    /******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    /******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
    /******/ 			}
    /******/ 			Object.defineProperty(exports, '__esModule', { value: true });
    /******/ 		};
    /******/ 	})();
    /******/ 	
    /******/ 	/* webpack/runtime/publicPath */
    /******/ 	(() => {
    /******/ 		var scriptUrl;
    /******/ 		if (__webpack_require__.g.importScripts) scriptUrl = __webpack_require__.g.location + "";
    /******/ 		var document = __webpack_require__.g.document;
    /******/ 		if (!scriptUrl && document) {
    /******/ 			if (document.currentScript)
    /******/ 				scriptUrl = document.currentScript.src;
    /******/ 			if (!scriptUrl) {
    /******/ 				var scripts = document.getElementsByTagName("script");
    /******/ 				if(scripts.length) {
    /******/ 					var i = scripts.length - 1;
    /******/ 					while (i > -1 && !scriptUrl) scriptUrl = scripts[i--].src;
    /******/ 				}
    /******/ 			}
    /******/ 		}
    /******/ 		// When supporting browsers where an automatic publicPath is not supported you must specify an output.publicPath manually via configuration
    /******/ 		// or pass an empty string ("") and set the __webpack_public_path__ variable from your code to use your own logic.
    /******/ 		if (!scriptUrl) throw new Error("Automatic publicPath is not supported in this browser");
    /******/ 		scriptUrl = scriptUrl.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/");
    /******/ 		__webpack_require__.p = scriptUrl;
    /******/ 	})();
    /******/ 	
    /******/ 	/* webpack/runtime/nonce */
    /******/ 	(() => {
    /******/ 		__webpack_require__.nc = undefined;
    /******/ 	})();
    /******/ 	
    /************************************************************************/
    var __webpack_exports__ = {};
    // This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
    (() => {
    var __webpack_exports__ = {};
    __webpack_require__.r(__webpack_exports__);
    /* harmony export */ __webpack_require__.d(__webpack_exports__, {
    /* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
    /* harmony export */ });
    /* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6);
    /* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
    /* harmony import */ var _node_modules_file_loader_dist_cjs_js_ruleSet_1_rules_0_use_1_node_modules_sass_loader_dist_cjs_js_readmore_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
    
          
          
          
          
          
          
          
          
          
    
    var options = {};
    
    options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
    options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());
    
          options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
        
    options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
    options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());
    
    var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_file_loader_dist_cjs_js_ruleSet_1_rules_0_use_1_node_modules_sass_loader_dist_cjs_js_readmore_scss__WEBPACK_IMPORTED_MODULE_6__["default"], options);
    
    
    
    
           /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_file_loader_dist_cjs_js_ruleSet_1_rules_0_use_1_node_modules_sass_loader_dist_cjs_js_readmore_scss__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_file_loader_dist_cjs_js_ruleSet_1_rules_0_use_1_node_modules_sass_loader_dist_cjs_js_readmore_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_file_loader_dist_cjs_js_ruleSet_1_rules_0_use_1_node_modules_sass_loader_dist_cjs_js_readmore_scss__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);
    
    })();
    
    // This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
    (() => {
    __webpack_require__.r(__webpack_exports__);
    /* harmony import */ var _readmore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);
    
    window.addEventListener("DOMContentLoaded", function (event) {
      var readmore = new _readmore__WEBPACK_IMPORTED_MODULE_0__["default"]();
      readmore.render();
    });
    })();
    
    /******/ })()
    ;